import i18n from "@/i18n";
import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { DeclarationPropertyValueData } from "../../data/declarationPropertyValueData";
import { DeclarationData } from "../../data/declarationData";
import { TemplateData } from "../../data/templateData";
import dateFilter from "../../filters/date.filter";
import { parseAmericanDate } from "../../utilities/parseHelper";
import { ContractsModel } from "../contracts/contractsModel";
import { CatalogOperationModel } from "../operations/catalogOperationModel";
import { getAmericanDate } from "../../utilities/parseHelper";
import { dateFormat } from "../../utilities/parseHelper";

/** Модель шаблона операции */
export class TemplateModel extends CatalogOperationModel {
  /**Периодичность операции */
  public Periods: Array<any> = [
    new DeclarationPropertyValueData(
      "0",
      i18n.t("main.templates.periodNo").toString()
    )
  ];

  /**Выбранный период */
  public SelectedPeriod: any = {};

  /**Следующая дата совершения операции (для периодического шаблона) */
  public NextDate: any = null;

  /**Нижний парог даты для пикера */
  public MinDate: string = "";

  public DateToday: string = "";

  /**Наименование шаблона */
  public Name: string = "";

  public OperationDetails: Array<any> = [];

  public EditTemplateCopy: TemplateData = new TemplateData();

  constructor(
    declaration: DeclarationData,
    template: OperationRequestData,
    tempData: TemplateData,
    contracts: ContractsModel | null = null
  ) {
    super(declaration, contracts, template);

    this.Periods.push(
      new DeclarationPropertyValueData(
        "1",
        i18n.t("main.templates.periodDaily").toString()
      )
    );
    this.Periods.push(
      new DeclarationPropertyValueData(
        "2",
        i18n.t("main.templates.periodWeek").toString()
      )
    );
    this.Periods.push(
      new DeclarationPropertyValueData(
        "3",
        i18n.t("main.templates.periodMonth").toString()
      )
    );

    this.SelectedPeriod = this.Periods[0];

    const dateNow = new Date();
    this.MinDate = getAmericanDate(
      dateFormat(dateNow.setDate(dateNow.getDate() + 1))
    );
    this.DateToday = getAmericanDate(dateFormat(Date.now(), "date"));

    if (declaration && template) {
      this.EditTemplateCopy.copy(tempData);
      this.Name = this.EditTemplateCopy.Name ?? "";

      this.SelectedPeriod =
        this.Periods.find((p: DeclarationPropertyValueData) => {
          return p.Key == this.EditTemplateCopy.Period.toString();
        }) ?? this.Periods[0];

      if (this.SelectedPeriod !== this.Periods[0]) {
        this.NextDate = getAmericanDate(dateFilter(this.EditTemplateCopy.NextDate, "date"));
      }
    }
  }

  /** Видимость даты совершения операции*/
  get dateNextVisibility(): boolean {
    return (
      !!this.SelectedPeriod &&
      (this.SelectedPeriod as DeclarationPropertyValueData).Key != "0"
    );
  }

  get dtNextDate(): Date | null {
    return parseAmericanDate(this.NextDate);
  }

  get displayNextDate(): string {
    return this.dtNextDate
      ? dateFormat(Date.parse(this.dtNextDate.toString()), "dateext")
      : "";
  }

  public prepareDataForRequest() {
    const p = parseInt(
      (this.SelectedPeriod as DeclarationPropertyValueData).Key
    );
    this.EditTemplateCopy.Period = parseInt(
      (this.SelectedPeriod as DeclarationPropertyValueData).Key
    );
    this.EditTemplateCopy.NextDate =
      p > 0 && this.dtNextDate ? Date.parse(this.dtNextDate.toString()) : null;
    this.EditTemplateCopy.DayNumber =
      p == 2
        ? (this.dtNextDate as Date).getDay()
        : p == 3
        ? (this.dtNextDate as Date).getDate()
        : 0;
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = super.createOperationRequest();
    //ord.SetProperty("templateId", td.Id.ToString(), DeclarationPropertiesTypes.Int);
    //ord.SetProperty("templateName", td.Name.ToString(), DeclarationPropertiesTypes.String);
    this.prepareDataForRequest();
    ord.setProperty(
      "templatePeriod",
      this.EditTemplateCopy.Period.toString(),
      DeclarationPropertiesTypes.Int
    );
    ord.setProperty(
      "templateDayNumber",
      this.EditTemplateCopy.DayNumber.toString(),
      DeclarationPropertiesTypes.Int
    );
    ord.setProperty(
      "templateNextDate",
      this.EditTemplateCopy.NextDate && this.EditTemplateCopy.Period > 0
        ? getAmericanDate(dateFormat(this.EditTemplateCopy.NextDate, "date"))
        : "",
      DeclarationPropertiesTypes.DateTime
    );

    ord.templateName = this.Name;
    ord.templateId = this.EditTemplateCopy.Id;

    return ord;
  }

  public setOperationDetails(details: Array<any>) {
    if (!details) return;
    this.OperationDetails = [];
    details.map((detail: any) => {
      if (detail) {
        this.OperationDetails.push({
          name: detail.Key,
          textVal: detail.Value
        });
      }
    });
  }
}
